module.exports = __webpack_public_path__ + "static/media/04510009-reh1wSgs.7ec0b0d9.JPG";